import React, { useEffect, useState } from 'react'
import "./detailsPage.css"
import axios from 'axios';
import { useParams } from 'react-router-dom';

export default function DetailsPage() {
    const { type, id } = useParams();
    const [details, setDetails] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        await axios.get(`https://winterns-server-aman.onrender.com/api/v1/action/findOne/${type}Details/${id}`)
            .then(res => {
                setIsLoading(false);
                const { data } = res.data;
                setDetails(data.document);
            })
            .catch(err => {
                setIsLoading(false);
                console.log(err);
            });
    }

    useEffect(() => {
        getData();
    });
    return (
        <div className='details-page'>
            {isLoading ? (
                <p>Loading</p>
            ) : (
                <p>{details.name}</p>
            )}
        </div>
    )
}
